<template>
<div class="cui-applications">
  <div class="cui-loading__container" v-if="spinner">
    <div class="cui-loading--center"><div class="cui-loading"></div></div>
  </div>
 <div class="cui-applications__new-request">
    <div class="cui-action">
        <div class="cui-action__title">New Request</div>
        <div class="cui-action__actions">
            <svg @click="$router.push('/applications')" xmlns="http://www.w3.org/2000/svg" class="cui-action__icon cui-action__icon--close" preserveAspectRatio="xMidYMid meet" viewBox="2 0 48 48" href="#/applications">
                <defs>
                    <ellipse id="path-1" cx="20" cy="19.672" rx="20" ry="19.672"></ellipse>
                    <filter x="-50%" y="-50%" width="200%" height="200%" filterUnits="objectBoundingBox" id="filter-2">
                        <feOffset dy="3" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
                        <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
                        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.27 0" in="shadowBlurOuter1"></feColorMatrix>
                    </filter>
                </defs>
                <g id="close-with-shadow" fill="none" fill-rule="evenodd">
                    <g id="Oval-73" transform="translate(3 1)">
                        <use fill="#000" filter="url(#filter-2)" xlink:href="#path-1"></use>
                        <use fill="currentColor" xlink:href="#path-1"></use>
                    </g>
                    <path d="M26.022 20.672l4.006-4.006c.788-.787.787-2.052.006-2.833l-.195-.195c-.788-.787-2.05-.778-2.834.006L23 17.65l-4.006-4.006c-.787-.788-2.052-.787-2.833-.006l-.194.195c-.788.787-.778 2.05.006 2.833l4.006 4.006-4.006 4.006c-.788.787-.787 2.053-.006 2.833l.195.196c.788.788 2.05.778 2.834-.006L23 23.695l4.006 4.005c.787.788 2.052.787 2.833.006l.194-.195c.788-.786.778-2.048-.006-2.832l-4.006-4.006z" fill="#fff"></path>
                </g>
            </svg>
        </div>
    </div>
    <div class="cui-action cui-action--alt">
        <h3 class="cui-action__title">Select Applications</h3>
        <div class="cui-action__actions">
            <svg cui-icon="" ng-click="newAppRequest.requestPopover=!newAppRequest.requestPopover" off-click="newAppRequest.requestPopover=false" xmlns="http://www.w3.org/2000/svg" id="cui-applications__requested-apps" class="cui-icon cui-icon--folder" ng-class="{'cui-action__icon--active': newAppRequest.numberOfRequests != 0}" preserveAspectRatio="xMidYMid meet" viewBox="0 0 40 33">
              <use class="cui-icon__ref" xlink:href="node_modules/@covisint/cui-icons/dist/icons/icons-out.svg#folder"></use>
            </svg>
            <sup class="cui-action__icon-counter" ng-class="{'cui-action__icon-counter--active': newAppRequest.numberOfRequests != 0}">0</sup>
        </div>
    </div>
    <div class="cui-applications__main-container">
        <div>
            <div class="cui-applications__search-options">
                <div class="cui-input-button">
                    <input type="text" class="cui-input-button__input ng-pristine ng-valid ng-empty ng-touched" ng-model="newAppRequest.search" placeholder="Search by application name" on-enter="newAppRequest.searchCallback" focus-if="" style="">
                    <button class="cui-input-button__button" ui-sref="applications.search({name:newAppRequest.search})" href="#/applications/search">Go</button>
                </div>
                <div class="cui-applications__center-text">Or</div>
                <a class="cui-link" href="#/applications/search">Show All</a>
            </div>
            <div >
             <v-expansion-panels style="width:75%">
           <v-expansion-panel
          v-for="(category) in categories"
          :key="category.id"
        >
         <v-expansion-panel-header  class="cui-applications__category" @click="$router.push({ path: '/applications/search', query: { category: category.name[0].text}})">{{category.name[0].text}}</v-expansion-panel-header>
           </v-expansion-panel>
             </v-expansion-panels>

            </div>
        </div>
    </div>
</div>
</div>
</template>

<script>
export default {
  data () {
    return {
      spinner: false,
      categories: []
    }
  },
  created () {
    this.spinner = true
    this.$API.getCategories()
      .then(res => {
        this.spinner = false
        this.categories = res
      })
      .fail(err => {
        this.spinner = false
        console.log('err', err)
      })
  },
  methods: {
    goToAppsCategory (category) {
      var categoryName = category.name[0].text
      // eslint-disable-next-line standard/object-curly-even-spacing
      this.$router.push({ name: '/applications/search', params: { category: categoryName}})
    }

  }
  /* eslint-disable */
}
</script>



// WEBPACK FOOTER //
// src/components/pages/applications/NewApplicationRequest.vue